import React from 'react'
import MeetingRoom from '../../containers/MeetingRoom/MeetingRoom'

const MeetingBooking = ({parentPage}) => <MeetingRoom parentPage={parentPage} />

export default MeetingBooking
